/**
 * The requests of the stock screen. The readings stay in `responses.ts`.
 */
import { z } from 'zod';
/**
 * The labels of the articles in the Modula: the rows ticked on the stock
 * screen, one label each (27/10/2026).
 *
 * The row travels as the screen showed it, product, colour and size included:
 * the label says what the person saw when they pressed *Stampa*. The barcode
 * does not come from here: the server turns `sku` into the code the Modula
 * knows.
 *
 * Two hundred at most: a drawer holds a few dozen boxes, and a request for
 * thousands is a slip, not a load.
 */
export const zEtichetteArticoli = z.object({
    varianti: z
        .array(z.object({
        /** `dn_sku_id`, as in `zGiacenza`. */
        sku: z.string().min(1),
        codice: z.string(),
        colore: z.string(),
        taglia: z.string(),
    }))
        .min(1)
        .max(200),
});
/**
 * Where the preview of those labels can be opened: an address of the API
 * that ends with the file name, valid ten minutes, opened without a login by
 * a browser tab (27/10/2026).
 */
export const zAnteprimaEtichette = z.object({ indirizzo: z.string().startsWith('/api/') });
//# sourceMappingURL=stock.js.map